import React from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import styles from "./styles/embedded-data-player.css.js";
import withStyles from "components/with-styles";
import { TextDisplay } from "components/display-data";
import CopyToClipboard from "components/copy-to-clipboard";
import { getEmbeddedPlayerUrl } from "config/paths";
import { useAuthDataContext } from "components/auth";

const PlayerTab = ({ event, intl, classes }) => {
  const { user } = useAuthDataContext();
  return (
    <TextDisplay className={classes.data} label={intl.formatMessage({ id: "event.externalPlayer.url" })}>
      <CopyToClipboard
        className={classes.copyToClipboard}
        textToCopy={`<iframe  style="border: 0 none;width: 99vw; height: 95vh" src="${getEmbeddedPlayerUrl({
          eventId: event.publicEventId,
          locale: user.locale,
        })}"><p>${intl.formatMessage({ id: "event.externalPlayer.error.iframe" })}</p></iframe>`}
      />
    </TextDisplay>
  );
};

PlayerTab.propTypes = {
  /**
   * Data to represent
   **/
  event: PropTypes.object,
};

export default withStyles(styles)(injectIntl(PlayerTab));
